import './bootstrap.js';
import './styles/app.scss';
import components from './js/components';
import modules from './js/modules';

[...components, ...modules].forEach((fn) => fn());
